/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Mac_Step1Inputs */

const en_gc_resources_download_mac_step1 = /** @type {(inputs: Gc_Resources_Download_Mac_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download and open the .dmg file.`)
};

const zh_gc_resources_download_mac_step1 = /** @type {(inputs: Gc_Resources_Download_Mac_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载并打开 .dmg 文件。`)
};

/**
* | output |
* | --- |
* | "Download and open the .dmg file." |
*
* @param {Gc_Resources_Download_Mac_Step1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_mac_step1 = /** @type {((inputs?: Gc_Resources_Download_Mac_Step1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Mac_Step1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_mac_step1(inputs)
	return zh_gc_resources_download_mac_step1(inputs)
});
export { gc_resources_download_mac_step1 as "gc.resources.download.mac.step1" }